(function() {
    window.c24Lp.isIos = function() {
        const iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ];
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) { return true; }
        }

        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            return true;
        }

        return false;
    };
})();
